export default __webpack_public_path__ + "static/media/cover.d47c22cf.png";